export const OWNER = 'owner';
export const TENANT = 'tenant';
export const DEFAULT_ROLE = 'default';
